import { ONBOARDING_COUNTRY_CODES } from '../onboardingFunnel/onboardingCountryPreferences'

/**
 * 국가별 지표(DAU/MAU · 회원가입수)의 표시 국가 설정.
 *
 * 온보딩 퍼널과 같은 편집기를 쓰지만 저장 키와 기본 목록은 따로 둔다.
 * 두 화면의 관심 국가가 다르고, 한쪽을 바꿨다고 다른 쪽이 따라 바뀌면 안 된다.
 */

/** 서버 기본값(utils/countryMetricsFilter)과 같은 8개국. 순서가 표시 순서다. */
export const DEFAULT_COUNTRY_METRICS_COUNTRIES = ['MX', 'BR', 'US', 'JP', 'CA', 'GB', 'ES', 'PT']

export const COUNTRY_METRICS_STORAGE_KEY = 'countryMetrics.visibleCountries.v1'

/** 서버가 한 번에 받는 국가 수 상한과 같아야 한다. 넘기면 400이 온다. */
export const MAX_COUNTRY_METRICS_COUNTRIES = 20

export const readCountryMetricsPreferences = () => {
    try {
        const stored = JSON.parse(localStorage.getItem(COUNTRY_METRICS_STORAGE_KEY))

        if (
            Array.isArray(stored)
            && stored.length > 0
            && stored.length <= MAX_COUNTRY_METRICS_COUNTRIES
            && stored.every(code => ONBOARDING_COUNTRY_CODES.includes(code))
        ) {
            return [...new Set(stored)]
        }
    } catch (_error) {
        // 브라우저 저장소를 못 쓰더라도 기본 목록으로 조회할 수 있어야 한다.
    }

    return [...DEFAULT_COUNTRY_METRICS_COUNTRIES]
}

export const saveCountryMetricsPreferences = (countries) => {
    try {
        localStorage.setItem(COUNTRY_METRICS_STORAGE_KEY, JSON.stringify(countries))
        return true
    } catch (_error) {
        return false
    }
}
